import { cva } from "class-variance-authority";

// The 16px checkbox of a checkbox tile, drawn like VCheckbox (primary border, 6px radius, white tick on primary) and
// sized like the radio of a radio tile. The tile carries the focus ring; the box adds its own ring like VRadio does.
export const checkboxTileBoxCva = cva(
  "flex size-4 shrink-0 items-center justify-center rounded-md border transition-colors duration-100 peer-focus-visible:ring-2 peer-focus-visible:ring-primary-500 peer-focus-visible:ring-offset-1",
  {
    variants: {
      checked: {
        true: null,
        false: null,
      },
      disabled: {
        true: null,
        false: null,
      },
      invalid: {
        true: null,
        false: null,
      },
    },
    compoundVariants: [
      { checked: true, disabled: false, class: "border-primary-500 bg-primary-500 text-white" },
      { checked: false, disabled: false, invalid: false, class: "border-primary-500 bg-white dark:bg-dark-800" },
      { checked: false, disabled: false, invalid: true, class: "border-danger-600 bg-white dark:bg-dark-800" },
      { checked: true, disabled: true, class: "border-gray-300 bg-gray-300 text-white dark:border-dark-500 dark:bg-dark-500" },
      { checked: false, disabled: true, class: "border-gray-300 bg-gray-100 dark:border-dark-600 dark:bg-dark-700" },
    ],
    defaultVariants: {
      checked: false,
      disabled: false,
      invalid: false,
    },
  },
);
